// const dynamicallyUnloadCss = (filename, filetype) => {
//   var elements = document.getElementsByTagName('link');
//   elements.forEach((element)=>{
//     if (element &&
//         element.getAttribute('href')!=null &&
//         element.getAttribute('href').indexOf(filename) !== -1){
//       element.parentNode.removeChild(element);
//     }
//   });

// }

import { data } from '../version/dataVersion';

export default function register() {

  const cacheBust = data.version;
  const dynamicallyLoadCss = (file) => {
    const link = document.createElement('link');
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("type", "text/css");
    link.onload = function(){ /*CSSDone();*/ }
    link.setAttribute("href", '/canvas-tree/css/' + file  + '?cacheBust=' + cacheBust);
    document.getElementsByTagName("head")[0].appendChild(link);
  }

  dynamicallyLoadCss('onsen-css-components-custom.css');
  dynamicallyLoadCss('onsenui.css');
  dynamicallyLoadCss('antd-mobile_custom.css');
  dynamicallyLoadCss('antd_custom.css');
  dynamicallyLoadCss('adaptedFamilytreeForms.css');


  /*

    Inside animate.min.css is css styles that should overwrite similar one in antd-mobile_custom.css

    @keyframes slideInRight {
      from {
        transform: translate3d(100%, 0, 0);
        visibility: visible;
      }

      to {
        transform: translate3d(0, 0, 0);
      }
    }

    .slideInRight {
      animation-name: slideInRight;
    }

   */

  dynamicallyLoadCss('animate.min.css');
};


